import React from 'react'
import { usePublication } from '../../../hooks/usePublication'
import { FragmentProps } from '../../../interfaces/Publication'
import parse from 'html-react-parser'

const Quote = ({fragment}: FragmentProps) => {

    const {path} = usePublication()

    return (
        <div className="grid">
            <div className="grid__cell">
                <figure className="bq-cite">
                    <img
                    className="bq-cite__img"
                    src={`${path}images/${fragment.img}`}
                    alt={fragment.title}
                    />
                    <blockquote className="blockquote">
                    {fragment.text?parse(fragment.text):null}
                    </blockquote>
                    <figcaption>
                    <cite><a href="#">{fragment.title?fragment.title:null}</a></cite>
                    </figcaption>
                </figure>
            </div>
        </div>
    )
}

export default Quote
